import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'journal-summary',
  templateUrl: './journal-summary.component.html',
  styleUrls: ['./journal-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JournalSummaryComponent implements OnInit {

  jsonObject: any = {};
  journal;

  @Input()
  set selection(selection: any) {
    this.journal = selection;
    this.jsonObject = selection ? { Details: JSON.parse(selection.value) } : null;
  }

  constructor() { }

  ngOnInit(): void {

  }


}
